<template>
  <div class="navbar-cashier">
    <!-- Bakiye Kutusu ve Dropdown -->
    <div class="cashier-balance" @click="toggleDropdown">
      <div class="balance-inner">
        <img :src="activeWalletIcon" :alt="activeWallet.coinType" />
        <AmountNumber
          :amount="activeWallet.balance"
          :symbol="getCurrencySymbol(selectedFiat)"
        />

        <svg
          style="margin-left: 6px; width: 12px; height: 12px"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M7 10l5 5 5-5"
            stroke="#fff"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>

      <div v-if="dropdownOpen" class="dropdown-menu" @click.stop>
        <div
          v-for="wallet in filteredWallets"
          :key="wallet.coinType + wallet.chain + wallet.type"
          class="wallet-item"
          @click="selectWallet(wallet)"
        >
          <img
            :src="getWalletIcon(wallet.coinType)"
            :alt="wallet.coinType"
            class="wallet-icon"
          />
          <span>{{ wallet.coinType }}</span>
          <AmountNumber
            :amount="wallet.balance"
            :symbol="getCurrencySymbol(selectedFiat)"
          />
        </div>

        <div class="dropdown-footer">
          <div class="switch-toggle" @click="hideZero = !hideZero">
            <span class="toggle-label"> {{ $t("Hide 0 balance") }}:</span>
            <div :class="['toggle-track', { active: hideZero }]">
              <div class="toggle-thumb"></div>
            </div>
          </div>

         
        </div>
      </div>
    </div>

    <!-- Wallet Butonu (sağda sarı kutu) -->
    <button @click="modalsSetShow('Cashier')" class="button-cashier-standalone">
      <IconCashier />
      <span>{{ $t("modal.25") }}</span>
      <img src="@/assets/img/chest.gif" alt="badge" class="wallet-badge" />
    </button>
  </div>
</template>


<script>
import { mapGetters, mapActions } from 'vuex';
import AmountNumber from '@/components/AmountNumber';
import IconCashier from '@/components/icons/IconCashier';
import axios from 'axios';

export default {
  name: 'NavbarCashier',
  components: {
    AmountNumber,
    IconCashier
  },
  data() {
    return {
      dropdownOpen: false,
      hideZero: false,
      supportedFiats: ['USD', 'EUR', 'TRY', 'BRL', 'CNY', 'INR', 'IDR'],
      selectedFiat: null,
    };
  },
  computed: {
    ...mapGetters(['authUser']),

     formattedAmount() {
      return Number(this.amount).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },

     activeWalletIcon() {
      // coin tipine göre svg yolunu döndür
      // coinType küçük-büyük harfe dikkat edebilirsiniz
      if (!this.activeWallet.coinType) return require('@/assets/img/coin.svg');
      
        return require(`@/assets/img/coins/${this.activeWallet.coinType}.svg`);
    
    },

    activeWallet() {
    const user = this.authUser.user;
    if (!user || !user.currency) return { balance: 0 };

    const { coinType, type, chain } = user.currency;
    return (
      user.wallets.find(
        w => w.coinType === coinType && w.type === type && w.chain === chain
      ) || { balance: 0 }
    );
  },

    filteredWallets() {
    const user = this.authUser.user;
    if (!user || !user.wallets) return [];
     return user.wallets
    .filter(wallet => !this.hideZero || wallet.balance > 0)
    .sort((a, b) => b.balance - a.balance);
},

   
  },
  mounted() {
  this.selectedFiat = this.authUser.user?.currency?.fiatCurrency || 'USD';
},
  methods: {
    ...mapActions(['modalsSetShow']),

    getWalletIcon(coinType) {
    
      return require(`@/assets/img/coins/${coinType}.svg`);
    },

    getCurrencySymbol(code) {
     const symbols = {
    USD: '$',     // US Dollar
    GBP: '£',     // British Pound
    CAD: 'C$',    // Canadian Dollar
    AUD: 'A$',    // Australian Dollar
    EUR: '€',     // Euro
    TRY: '₺',     // Turkish Lira
    BRL: 'R$',    // Brazilian Real
    MXN: '$',     // Mexican Peso
    INR: '₹',     // Indian Rupee
    JPY: '¥',     // Japanese Yen
    KRW: '₩',     // South Korean Won
    PHP: '₱',     // Philippine Peso
    ZAR: 'R',     // South African Rand
    RUB: '₽',     // Russian Ruble
    SEK: 'kr',    // Swedish Krona
    NOK: 'kr',    // Norwegian Krone
    DKK: 'kr',    // Danish Krone
    SGD: 'S$',    // Singapore Dollar
    MYR: 'RM',    // Malaysian Ringgit
    THB: '฿',     // Thai Baht
    VND: '₫',     // Vietnamese Dong
    ARS: '$',     // Argentine Peso
    COP: '$',     // Colombian Peso
    CLP: '$',     // Chilean Peso
    CNY: '¥',     // Chinese Yuan
    IDR: 'Rp',    // Indonesian Rupiah
    HKD: 'HK$',   // Hong Kong Dollar
    TWD: 'NT$',   // New Taiwan Dollar
    MOP: 'MOP$',  // Macanese Pataca
    BDT: '৳'      // Bangladeshi Taka
  };
    return symbols[code] || code;
  },

    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
    },

   async selectWallet(wallet) {
  try {
    await axios.post('/users/switch-wallet', {
      coinType: wallet.coinType,
      type: wallet.type,
      chain: wallet.chain
    });

    this.$store.dispatch('authGetUser'); // Güncellenmiş kullanıcıyı tekrar çek
    this.dropdownOpen = false;
  } catch (e) {
    console.error(e);
  }
},


    async switchFiat() {
      try {
        const res = await axios.post('/exchange/switch-fiat-currency', {
          userId: this.authUser.user._id,
          newFiat: this.selectedFiat
        });
        if (res.data.success) {
          this.$store.dispatch('authGetUser');
        }
      } catch (e) {
        console.error(e);
      }
    }
  }
};
</script>


<style scoped>
   .navbar-cashier {
  display: flex;
  align-items: center;
  margin-right: 10px;
   
  border-radius: 12px;
  background: var(--background2);
  
}

    .navbar-cashier button.button-cashier {
        height: 42px;
        position: relative;
        margin-right: -50px;
        padding: 1px;
        
    }

    .navbar-cashier button.button-cashier::before {
        content: '';
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        
        border-radius: 10px;
    }

    .navbar-cashier button.button-cashier .button-inner {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 15px 0 14px;
        font-size: 16px;
        font-weight: 800;
        color: #ffffff;
        background: linear-gradient(1turn, #00c45e .8%, #0e8849);
    box-shadow: 0 3px 16px #6eff2369, inset 0 4px 3px #ffffff4d;
        border-radius: 10px;
    }

    .navbar-cashier button.button-cashier .button-inner svg {
        
        fill: #ffffff;
    }

    .navbar-cashier .cashier-balance {
        
        height: 40px;
        position: relative;
        padding: 1px;
        
    }

    .navbar-cashier .cashier-balance::before {
        content: '';
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        border-radius: 10px;
        z-index: 0;
    }

    .navbar-cashier .cashier-balance button.button-free {
        height: 21px;
        position: absolute;
        top: -11px;
        right: 0;
   
        z-index: 1;
    }

    
 

    .navbar-cashier .balance-inner {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 12px;
        background: var(--background2);
        border-radius: 12px;
        z-index: 1;
         gap: 10px;
    }

 
.balance-inner .amount-number { 
  font-variant-numeric: tabular-nums;    /* her rakam eşit genişlik */
  letter-spacing: 0.5px;                 /* okunabilirlik için */
  font-size: 14px;
  font-weight: 600;
  color: #fff;
}

    .navbar-cashier .balance-inner img {
        width: 18px;
        height: 18px;
    }

    .navbar-cashier .inner-value {
        font-size: 12px;
        font-weight: 600;
        color: #c1c1c1;
    }

    .navbar-cashier .inner-value span {
        font-size: 12px;
        font-weight: 800;
        color: #ffffff;
    }


   .button-cashier-standalone {
     height: 36px;
    display: flex;
    align-items: center;
    padding: 0 12px;
    background: var(--buttonyellow);
        box-shadow:rgb(197, 106, 24) 0px -3px 0px 0px inset, rgb(255, 234, 47) 0px 2px 0px 0px inset;
    border-radius: 5px;
    border: none;
    position: relative;
    font-size: 13px;
    font-weight: 700;
    color: #000;
    cursor: pointer;
    margin-left: 10px;
}



.button-cashier-standalone svg {
  width: 18px;
  height: 18px;
  fill: #000;
  
}

/* Wallet yazısı */
.button-cashier-standalone span {
  display: inline-block;
  line-height: 1;
}

/* Sağ üstte gif (badge, animasyon vb.) */
.button-cashier-standalone .wallet-badge {
  position: absolute;
  top: -13px;
  right: -8px;
  width: 30px;
  height: 30px;
  pointer-events: none;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
      
    border-radius: 12px;
    background: var(--dropdownbg);
  width: 240px;
  margin-top: 5px;
  padding: 10px;
  z-index: 999;
}
.switch-toggle {
  display: flex;
  align-items: center;
  cursor: pointer;
  gap: 10px;
}

.toggle-track {
  width: 40px;
  height: 20px;
  background: #555;
  border-radius: 10px;
  position: relative;
  transition: background 0.2s;
}

.toggle-track.active {
  -webkit-text-stroke-color: rgb(25, 25, 57);
    background: rgb(44, 40, 82);
    color: rgb(217, 209, 244);
    box-shadow: rgb(35, 32, 66) 0px -3px 0px 0px inset, rgb(89, 81, 142) 0px 2px 0px 0px inset;
    text-shadow: rgb(25, 25, 57) 0px 1px 0px;
}

.toggle-thumb {
  width: 18px;
  height: 18px;
  background: #fff;
  border-radius: 50%;
  position: absolute;
  top: 1px;
  left: 1px;
  transition: transform 0.2s;
}

.toggle-track.active .toggle-thumb {
  transform: translateX(20px);
}

.toggle-label {
  font-size: 13px;
  color: #ccc;
}
.wallet-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 0;
  color: #fff;
  cursor: pointer;
}

.dropdown-footer {
  margin-top: 10px;
  border-top: 1px solid #1a4e57;
  padding-top: 8px;
  font-size: 13px;
  color: #ccc;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.wallet-icon {
  width: 24px;
  height: 24px;
  
  
}

.wallet-item span {
    font-family: var(--font-header);
    font-size: 14px;
    font-weight: 600;
}

.switch-toggle,
.currency-select {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}


    @media only screen and (max-width: 1175px) {

        .navbar-cashier button.button-cashier {
            height: 38px;
        }

        .navbar-cashier button.button-cashier .button-inner {
            padding: 0 13px;
        }

        .navbar-cashier button.button-cashier .button-inner svg {
            width: 14px;
        }


        .navbar-cashier button.button-cashier .button-inner svg {
            margin-right: 0;
        }

        .navbar-cashier button.button-cashier .button-inner span {
            display: none;
        }


        .navbar-cashier .cashier-balance {
            width: auto;
            height: 40px;
        }

        .navbar-cashier .cashier-balance button.button-free {
            height: 16px;
            top: -8px;
        }

        .navbar-cashier .cashier-balance button.button-free .button-inner {
            padding: 0 6px;
            font-size: 8px;
        }

        .navbar-cashier .balance-inner {
            padding: 0 12px 0 5px;
        }

        .navbar-cashier .balance-inner img {
            width: 24px;
            height: 24px;
            margin-right: 10px;
        }

        .button-cashier-standalone span {
  display: none;
}

    }
</style>
